import { TicketTemplate, TicketTemplateField } from "@/types/ticket";
import { computed, ComputedRef, Ref } from "vue";

const defaultFieldOrder = [
  "priority",
  "custom_1",
  "custom_2",
  "zone",
  "equipment",
  "product",
  "labels",
];

type TicketTemplateFieldForTemplate = TicketTemplateField & {
  nudge: boolean;
  nudgeIsShown: boolean;
  name: string;
  placeholder: string;
  help: string;
  label: string;
};

export const useTicketTemplateFieldOrder = (
  ticketTemplate: Ref<TicketTemplate> | ComputedRef<TicketTemplate>,
  fields:
    | Ref<TicketTemplateFieldForTemplate[]>
    | ComputedRef<TicketTemplateFieldForTemplate[]>
) => {
  function getFieldOrder(key: string) {
    const field = fields.value?.find((f: any) => f.label === key);
    return field?.order ?? defaultFieldOrder.indexOf(key) + 1;
  }

  function getOrderableFieldsOrder() {
    if (!ticketTemplate.value) return defaultFieldOrder;
    const fieldOrder = defaultFieldOrder.map((key) => {
      return {
        key,
        order: getFieldOrder(key),
      };
    });
    return fieldOrder
      .sort((a, b) => {
        const diff = a.order - b.order;
        if (diff !== 0) return diff;
        return a.key.localeCompare(b.key);
      })
      .map((o) => o.key);
  }

  return computed(getOrderableFieldsOrder);
};
